import { Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToSection } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="bg-ink text-cream pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <p className="font-serif font-black text-[16vw] lg:text-[9rem] leading-none text-cream/5 select-none pointer-events-none -mb-6 lg:-mb-12">
          Baeboo's
        </p>
        <div className="relative grid md:grid-cols-3 gap-10 border-t border-cream/10 pt-10">
          <div>
            <p className="font-serif font-bold text-2xl">Baeboo's <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50">Wardrobe</span></p>
            <p className="text-sm text-cream/60 leading-relaxed mt-4">
              Organic cotton couture for little explorers. Cut, block-printed and stitched in Bangalore — loved across India.
            </p>
            <Link
              to="/admin"
              className="inline-block mt-4 font-mono text-[10px] tracking-[0.3em] uppercase text-cream/40 hover:text-terracotta transition-colors"
              data-testid="footer-admin-link"
            >
              Admin
            </Link>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-4">Shop</p>
            <ul className="space-y-2.5 text-sm text-cream/80">
              <li><button className="hover:text-terracotta transition-colors" onClick={() => scrollToSection("#shop")} data-testid="footer-link-collection">The Collection</button></li>
              <li><button className="hover:text-terracotta transition-colors" onClick={() => scrollToSection("#size-guide")} data-testid="footer-link-sizeguide">Size Guide</button></li>
              <li><button className="hover:text-terracotta transition-colors" onClick={() => scrollToSection("#reviews")} data-testid="footer-link-reviews">Parent Reviews</button></li>
              <li><button className="hover:text-terracotta transition-colors" onClick={() => scrollToSection("#manifesto")} data-testid="footer-link-craft">Craft Manifesto</button></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-4">Visit / Write</p>
            <ul className="space-y-3 text-sm text-cream/80">
              <li className="flex gap-2"><MapPin className="w-4 h-4 shrink-0 text-terracotta" /> Baeboo's Wardrobe, Bangalore, India</li>
              <li className="flex gap-2"><Mail className="w-4 h-4 shrink-0 text-terracotta" /> <a href="mailto:wardrobe.baeboos@gmail.com" className="hover:text-terracotta transition-colors" data-testid="footer-email-link">wardrobe.baeboos@gmail.com</a></li>
              <li className="text-cream/60">Open Mon–Sat, 10am–7pm</li>
            </ul>
          </div>
        </div>
        <div className="relative flex flex-wrap items-center justify-between gap-4 border-t border-cream/10 mt-10 pt-6">
          <p className="font-mono text-[10px] tracking-widest text-cream/50">© 2026 Baeboo's Wardrobe · Made with love in Bangalore</p>
          <div className="flex gap-2" data-testid="footer-payment-badges">
            {["UPI", "GPay", "PhonePe", "Paytm"].map((p) => (
              <span key={p} className="font-mono text-[10px] tracking-wider border border-cream/20 rounded-full px-3 py-1 text-cream/70">{p}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
